import CeptaaMap from "./ceptaamap";

var ceptaaMap = new CeptaaMap();
ceptaaMap.init();



// WEBPACK FOOTER //
// ./scripts/main.js